/**
 * change `localDevOverride` to false if you want to rely on domain
 */

const localDevOverride = process.env.NODE_ENV === 'development' ? true : false;

const isAzoomee = document.location.href.includes('azoomee') || localDevOverride;


export default isAzoomee